<template>
  <div >
    <div class="dd-right">
        
    </div>
  </div>
</template>
   
<script>
export default {
  data() {
    return {
     
    };
  },
};
</script>
<style scoped>
 .dd-right{
   width: 645px;
   height: 1080px;
   background-image: url("../assets/dd/dd-bg50.png");
    background-repeat: no-repeat;
 }
</style>



// WEBPACK FOOTER //
// src/pages/dd_right.vue